import { useTranslation } from 'react-i18next';
import { Badge, type Tone } from '@/ui';

/** The legacy console's bands: below 38 Bad, below 58 Good, otherwise Great. */
export function scoreBand(score: number): { band: 'bad' | 'good' | 'great'; tone: Tone } {
  if (score < 38) return { band: 'bad', tone: 'danger' };
  if (score < 58) return { band: 'good', tone: 'warning' };
  return { band: 'great', tone: 'success' };
}

/** A customer's user score as a coloured band ("72 · Great"), or "N/A" when there is none. */
export function UserScore({ score, showValue = true, size = 'sm' }: { score: number | null | undefined; showValue?: boolean; size?: 'sm' | 'lg' }) {
  const { t } = useTranslation('common', { keyPrefix: 'userScore' });
  const className = size === 'lg' ? 'h-8 px-3 text-base' : undefined;
  if (typeof score !== 'number' || Number.isNaN(score)) return <Badge tone="neutral" className={className}>{t('none')}</Badge>;
  const { band, tone } = scoreBand(score);
  return <Badge tone={tone} className={className}>{showValue ? `${score} · ${t(band)}` : t(band)}</Badge>;
}
